import { LayoutComponent } from "@jelly/lesson";

import * as recording from "./full-sound/recording";
import * as synthesis from "./full-sound/synthesis";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "controlsToggleExtraContent",
      options: {
        controls: [
          {
            type: "button",
            options: {},
            items: [{ name: "Recording" }, { name: "Synthesis" }],
          },
        ],
        controlsPosition: "bottom",
        extraContent: [recording.extraContent, synthesis.extraContent],
        components: [recording.components, synthesis.components],
      },
    },
  },
];

export default components;
